module.exports = __webpack_public_path__ + "static/media/rare_booster.08eb19e4.webp";